import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Link } from 'gatsby'
import { ElementHTML } from '@helpers/helper.rendering'

const TestimonialsBoxThree = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    testimonials,
    button,
    titleElement,
    subtitleElement,
    paragraphElement,
    itemIndexElement, //firma
    titleHexa,
    paragraphHexa,
    subtitleHexa,
    titleColor, //firma
    backgroundColor,
  } = props

  return (
    <section
      className="box-testimonials-b p-y-config"
      style={{ background: backgroundColor || 'red' }}
    >
      <div className="container-fluid">
        <ElementHTML
          className="text-center main-title"
          children={title}
          style={{ color: titleHexa }}
          elementType={titleElement || 'h2'}
        />
        <div className="row my-lg-5 mt-4 py-lg-4">
          {testimonials?.map((testimony, index) => (
            <div
              className="col-lg-4 mb-4"
              key={index}
            >
              <ElementHTML
                elementType={subtitleElement || 'h4'}
                className="subtitle"
                children={testimony.subtitle}
                style={{ color: subtitleHexa || '#000' }}
              />
              <ElementHTML
                elementType={paragraphElement || 'p'}
                className="paragraph"
                children={testimony.paragraph}
                style={{ color: paragraphHexa || '#000' }}
              />
              <ElementHTML
                elementType={itemIndexElement || 'h5'}
                className="mt-2"
                children={testimony.title}
                style={{ color: titleColor || '#1f1f1f' }}
              />
            </div>
          ))}
        </div>
        {button?.link && (
          <div className="d-flex w-100 justify-content-center">
            <Link
              className={
                'text-center d-inline-flex btn btn-primary mx-auto ' +
                (button?.border ? 'border' : '')
              }
              to={button?.link}
            >
              {button.value}
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}

export default TestimonialsBoxThree
